import { BrandBgEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgUnUseVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgUnUseVO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly value: RoomBrandBgUnUse) {
    JsonSchemaValidator.assert(RoomBrandBgUnUseVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandBg"],
      properties: {
        roomId,
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgUnUse {
  roomId: RoomId;
  brandBg: BrandBgEntity;
}
